<div class="form-floating">
  <ng-select
    #select
    class="form-control"
    [items]="displayedLocations()"
    bindValue="id"
    [minTermLength]="3"
    [loading]="locationsLoading"
    [typeToSearchText]="'ct-library.location-input.search-text' | transloco"
    [notFoundText]="
      notFoundText() ||
      ('ct-library.constants.ng-select.placeholders.not-found' | transloco)
    "
    [typeahead]="locationsInput$"
    [formControl]="control"
    (open)="select.filter(label())"
    (clear)="reset()"
    (change)="onChange($event)"
    [inputAttrs]="{
      autocomplete: 'chrome-off',
      'allow-1password': 'no',
      type: 'search',
    }"
    id="location"
    appendTo="body"
    [placeholder]="'ct-library.ng-select.placeholders.placeholder' | transloco"
  >
    <ng-template ng-option-tmp let-item="item">
      <b>{{ item?.label }}</b>
    </ng-template>
    <ng-template ng-label-tmp let-item="item">
      {{ label() }}
    </ng-template>
  </ng-select>
  <label for="location">{{
    placeholder ?? ('ct-library.location-input.placeholder' | transloco)
  }}</label>
</div>
